<template>
  <div class="container">
    <h2>{{ $t("ELIXIO_CONNECT.ELIXIO_TAB_DATA_TITLE") }}</h2>

    <div class="service-connect-old">
      <div class="form-wrapper">
        <base-input
          :label="`${$t('ELIXIO_CONNECT.ELIXIO_START_IMPORT_AT')}`"
          :placeholder="$t('ELIXIO_CONNECT.ELIXIO_START_IMPORT_AT')"
        >
          <el-date-picker
            v-model="createdAfter"
            type="date"
            format="dd MMM yyyy"
            value-format="yyyy-MM-dd"
            :clearable="false"
            class="w-100"
            :placeholder="$t('ELIXIO_CONNECT.SELECT_DATE')"
          />
        </base-input>
      </div>

      <div class="service-connect-old-status" v-if="!batch">
        <base-alert
          v-if="completeStatus != ''"
          :type="completeStatus == 'completed' ? 'success' : 'danger'"
          dismissible
        >
          {{ $t(`ELIXIO_CONNECT.ELIXIO_CONNECT_${completeStatus.toUpperCase()}`) }}
        </base-alert>

        <el-button
          type="btn kw-button"
          @click="connect"
          :loading="loading"
          :disabled="loading"
        >
          {{ $t("ELIXIO_CONNECT.ELIXIO_START_CONNECT") }}
        </el-button>
      </div>

      <div v-else class="service-connect-old-content">
        <h3>{{ $t("ELIXIO_CONNECT.ELIXIO_CONNECT_TOTAL_PROGRESS") }}</h3>
        <el-progress
          :percentage="batch.progress"
          :text-inside="true"
          :stroke-width="24"
        />
        <ul class="list-group list-group-flush">
          <li v-for="job in jobs" :key="job.id">
            <span>{{ job.name }}</span>
            <span :class="`badge badge-${job.pending ? 'yellow' : 'success'}`">
              {{
                $t(
                  `ELIXIO_CONNECT.ELIXIO_CONNECT_STATUS_${
                    job.pending ? "PENDING" : "DONE"
                  }`
                )
              }}
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";
import {
  Tooltip,
  Button,
  Row,
  Tag,
  Col,
  Card,
  Progress,
  Badge,
  DatePicker,
} from "element-ui";

export default {
  name: "ModuleDataBatchSync",

  components: {
    [Tooltip.name]: Tooltip,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Row.name]: Row,
    [Col.name]: Col,
    [Card.name]: Card,
    [Progress.name]: Progress,
    [Badge.name]: Badge,
    [DatePicker.name]: DatePicker,
  },

  props: ["organization", "service"],

  data() {
    const storage = localStorage.getItem("BATCH");
    const batchData = storage ? JSON.parse(storage) : null;

    return {
      loading: false,
      batch: batchData,
      intervalId: null,
      completeStatus: "",
      createdAfter: null,
    };
  },

  created() {},

  mounted() {
    if (this.batch) {
      this.startTimer();
    }
  },

  computed: {
    jobs() {
      if (!this.batch) {
        return [];
      }

      return [
        {
          id: "customers",
          name: this.$t("ELIXIO_CONNECT.ELIXIO_UPDATED_CUSTOMERS"),
          pending:
            !this.batch.progress ||
            (this.batch.progress != 100 && this.batch.pendingJobs > 2),
        },
        {
          id: "invoices",
          name: this.$t("ELIXIO_CONNECT.ELIXIO_UPDATED_INVOICES"),
          pending:
            !this.batch.progress ||
            (this.batch.progress != 100 && this.batch.pendingJobs > 1),
        },
        {
          id: "payments",
          name: this.$t("ELIXIO_CONNECT.ELIXIO_UPDATED_PAYMENTS"),
          pending: !this.batch.progress || this.batch.progress != 100,
        },
      ];
    },
  },

  methods: {
    async connect() {
      const result = await swal.fire({
        text: this.$t("ELIXIO_CONNECT.ELIXIO_CONNECT_CONFIRM_THIS_SUBSCRIPTION"),
        customClass: {
          popup: "warning-confirm",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
        showLoaderOnConfirm: this.loading,
        allowOutsideClick: () => !swal.isLoading(),
      });

      if (!result.isConfirmed) {
        return;
      }

      try {
        this.loading = true;

        const { data, status } = await this.$store.dispatch(
          "elixioConnectModule/syncBatch",
          {
            organizationId: this.organization.id,
            serviceType: this.service.slug,
            createdAfter: this.createdAfter,
          }
        );

        if (status != 200) {
          return;
        }

        this.batch = data.batch;

        this.startTimer();
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    startTimer() {
      this.intervalId = setInterval(() => this.get(), 5000); // 5s
    },

    async get() {
      try {
        const { data, status } = await this.$store.dispatch(
          "elixioConnectModule/getBatch",
          {
            organizationId: this.organization.id,
            batchId: this.batch.id,
          }
        );

        if (status == 400) {
          this.stopTimer();
        }

        if (status != 200) {
          return;
        }

        this.batch = data;
      } catch (e) {
        console.error(e);
      } finally {
      }
    },

    stopTimer() {
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.batch = null;
    },
  },

  watch: {
    batch: {
      handler(newValue, oldValue) {
        localStorage.setItem(
          "BATCH",
          newValue ? JSON.stringify(newValue) : null
        );

        if (newValue && newValue.cancelledAt) {
          this.completeStatus = "canceled";

          this.$notify({
            type: "danger",
            message: this.$t("ELIXIO_CONNECT.ELIXIO_CONNECT_CANCELLED"),
          });

          this.stopTimer();
        }

        if (newValue && newValue.progress == 100) {
          this.completeStatus = "completed";

          this.$notify({
            type: "success",
            message: this.$t("ELIXIO_CONNECT.ELIXIO_CONNECT_COMPLETED"),
          });

          this.stopTimer();
        }
      },
    },
  },
};
</script>

<style lang="scss">
.service-connect-old {
  margin: 20px 0 0 0;
  &-status {
    .alert {
      padding: 10px 15px;
      border-radius: 8px;
      .alert-text {
        font-family: "Greycliff CF Bold";
        font-size: 15px;
      }
      .close {
        right: 12px;
        span {
          font-size: 40px;
          font-weight: 200;
        }
      }
    }
  }
  &-content {
    .el-progress {
      margin: 12px 0 0 0;
      .el-progress-bar {
        &__inner {
          background-color: var(--tertiary);
        }
      }
    }
    .list-group {
      margin: 15px 0 0 0;
      li {
        margin: 0 0 10px 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        &:last-of-type {
          margin: 0;
        }
        span {
          margin: 0 0 5px 0;
          display: block;
          font-family: "Greycliff CF Medium";
          &:last-of-type {
            margin: 0;
          }
          &.badge {
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
  }
  .kw-button {
    width: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    min-height: 48px;
    border-radius: 8px;
    background-color: var(--primary);
    border: solid 1px var(--primary);
    margin: 0 10px 0 0;
    padding: 0 40px;
    color: #fff;
    font-family: "Greycliff CF Bold", sans-serif;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    &:hover {
      background-color: var(--darken-primary);
    }
  }
}
</style>
